import React from "react";
import { BrowserRouter } from "react-router-dom";
import "typeface-roboto";
import { AuthorizedApolloProvider } from "./apolloClient";
import { SnackbarProvider } from "notistack";
import { Routes } from "./Routes";
import "./translations";
import { CssBaseline } from "@material-ui/core";
import { Auth0Provider } from "@auth0/auth0-react";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import "mapbox-gl/dist/mapbox-gl.css";
import { LanguageProvider, BrandThemeProvider } from "./contexts";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import appInit from './appInit';
import TagManager from "react-gtm-module";


if (process.env.REACT_APP_GTM) TagManager.initialize({ gtmId: process.env.REACT_APP_GTM });

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

// Call the App Init 
appInit();

const App = () => {
  return (
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH0_DOMAIN}
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
      redirectUri={`${window.location.origin}/provider/auth0callback`}
      audience={process.env.REACT_APP_AUTH0_AUDIENCE}
    >
      <AuthorizedApolloProvider>
        <BrandThemeProvider>
          <CssBaseline />
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <SnackbarProvider maxSnack={1}>
              <BrowserRouter>
                <LanguageProvider>
                  {() => (
                    <Elements stripe={stripePromise}>
                      <Routes />
                    </Elements>
                  )}
                </LanguageProvider>
              </BrowserRouter>
            </SnackbarProvider>
          </MuiPickersUtilsProvider>
        </BrandThemeProvider>
      </AuthorizedApolloProvider>
    </Auth0Provider>
  );
};

export default App;
